module.exports = __webpack_public_path__ + "img/academy_effect_com.404dbbae.png";